import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";

import LargeNumber from "../../info-list/content/large-number";


import "./temperature-bar.scss";

const TemperatureBar = ({ children, hasDot = false, isHealthy = null, percent = 0, score = null, cssClass = [] }) => {
    const $bar = useRef();
    const [pos, setPos] = useState(0);
    const healthClass = isHealthy === false ? "-unhealthy" : isHealthy ? "-healthy" : "";

    useEffect(() => {
        const update = () => setPos($bar.current ? $bar.current.offsetWidth * (percent / 100) : 0);
        const observer = new ResizeObserver(update);
        if ($bar.current) observer.observe($bar.current);
        update();
        return () => observer.disconnect();
    }, [$bar, percent]);

    return (
        <div className="temperature-bar-wrapper">
            <div className={classnames("temperature-bar", healthClass, cssClass)}>
                <div className="bar" ref={$bar}>
                    {!hasDot && <div className="line" style={{ width: `${percent}%` }}></div>}
                    {hasDot && <div className="dot" style={{ left: `${pos - 2}px` }}></div>}
                </div>
                {children && <div className="label">{children}</div>}
            </div>
            {score && <LargeNumber value={score} isHealthy={isHealthy} />}
        </div>
    );
};

export default TemperatureBar;
